// Utility functions for filter management

export const clearSavedFilters = () => {
  try {
    localStorage.removeItem('raastafix-admin-filters');
  } catch (error) {
    console.error('Error clearing filters from localStorage:', error);
  }
};

export const saveFilters = (filters: any) => {
  try {
    localStorage.setItem('raastafix-admin-filters', JSON.stringify(filters));
  } catch (error) {
    console.error('Error saving filters to localStorage:', error);
  }
};

export const loadSavedFilters = () => {
  try {
    const savedFilters = localStorage.getItem('raastafix-admin-filters');
    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);
      // Convert date strings back to Date objects
      return {
        ...parsed,
        startDate: parsed.startDate ? new Date(parsed.startDate) : undefined,
        endDate: parsed.endDate ? new Date(parsed.endDate) : undefined,
      };
    }
  } catch (error) {
    console.error('Error parsing saved filters:', error);
  }
  return null;
};

